import { render, staticRenderFns } from "./downloadArea.vue?vue&type=template&id=2f640b9c&scoped=true&"
import script from "./downloadArea.vue?vue&type=script&lang=js&"
export * from "./downloadArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f640b9c",
  null
  
)

export default component.exports